// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1Kyzp","imageUploader":"EGiftCard_imageUploader__3jYaS"};